import { createSlice } from "@reduxjs/toolkit";
import {
  getCommentsByUserId,
  getCommentsByWorkFlowId,
  addComment,
  getLastComment,
  uploadAttachmentOfComments,
  editCommentById,
  deleteComment,
} from "api/comments";

const initialState = {
  comments: [],
  loading: false,
  start: 0,
  limit: 10,
  sortBy: null,
  sortOrder: null,
  error: null,
  total: 0,
  uploadedListAttachmentOfComments: [],
  isUploadAttachmentOfCommentsLoading: false,
  addedANewComment: false,
  deleteCommenttoaster: false,
  editCommenttoaster: false,
  deleteAttachedDocument: [],
  selectedcomment: {},
  selectedCommentAttachment: {}
};

export const commentsReducer = createSlice({
  name: "commentsReducer",
  initialState,
  reducers: {
    setStart: (state, action) => {
      state.start = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    setSortBy: (state, action) => {
      state.sortBy = action.payload;
    },
    setSortOrder: (state, action) => {
      state.sortOrder = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setComments: (state, action) => {
      state.comments = [...state.comments, ...action.payload];
    },
    setTotal: (state, action) => {
      state.total = action.payload;
    },
    clearComments: (state, action) => {
      state.comments = [];
    },
    clearSelectedComment: (state, action) => {
      state.selectedcomment = {}
    },
    resetCommentsState: (state) => {
      state.comments = [];
      state.loading = false;
      state.start = 0;
      state.limit = 10;
      state.sortBy = null;
      state.sortOrder = null;
      state.error = null;
      state.total = 0;
      state.uploadedListAttachmentOfComments = [];
      state.isUploadAttachmentOfCommentsLoading = false;
      state.addedANewComment = false;
      state.deleteCommenttoaster = false;
      state.editCommenttoaster = false;
      state.selectedcomment = {};
      state.deleteAttachedDocument = [];
      state.selectedCommentAttachment = [];
    },
    setAddedNewComment: (state, action) => {
      state.addedANewComment = action.payload;
    },
    setdeleteComment: (state, action) => {
      state.deleteCommenttoaster = action.payload;
    },
    seteditComment: (state, action) => {
      state.editCommenttoaster = action.payload;
    },
    setSelectedComment: (state, action) => {
      state.selectedcomment = action.payload;
    },
    setdeleteAttachedComment: (state, action) => {
      return {
        ...state,
        deleteAttachedDocument: [
          ...state.deleteAttachedDocument,
          action.payload,
        ],
      };
    },
    setSelectedCommentAttachment: (state, action) => {
      state.selectedCommentAttachment = action.payload;
    },
    updateAttachments: (state, action) => {
      const payload = action.payload;
      const selectedAttachment = state.selectedCommentAttachment;
      let updatedAttachment = selectedAttachment;

      if (Array.isArray(selectedAttachment)) {
        updatedAttachment = selectedAttachment.filter((item) => {
          return !payload.includes(item?.encrypted_filename);
        });
      }
      return {
        ...state,
        selectedCommentAttachment: updatedAttachment,
      };
    },
    resetAddedNewComment: (state, action) => {
      state.addedANewComment = false;
    },
    reseteditCommenttoaster: (state, action) => {
      state.editCommenttoaster = false;
    },
    resetdeleteCommenttoaster: (state, action) => {
      state.deleteCommenttoaster = false;
    },
    deleteAnUploadedFileFromAttachment: (state, action) => {
      state.uploadedListAttachmentOfComments =
        state.uploadedListAttachmentOfComments.filter(
          (item) => item?.encrypted_filename !== action.payload
        );
    },
    clearUploadedListAttachmentOfComments: (state, action) => {
      state.uploadedListAttachmentOfComments = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCommentsByUserId.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getCommentsByUserId.fulfilled, (state, action) => {
        state.loading = false;
        state.comments = [...state?.comments, ...action.payload?.data];
        state.total = action.payload.count;
        state.error = null;
        state.start = state.start + state.limit;
      })
      .addCase(getCommentsByUserId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(addComment.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addComment.fulfilled, (state, action) => {
        state.loading = false;
        state.comments = action.payload.data;
        state.start = state.start + 1;
        state.total = state.total + 1;
        state.uploadedListAttachmentOfComments = [];
        state.addedANewComment = true;
        state.error = null;
      })
      .addCase(addComment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(getLastComment.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getLastComment.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(getLastComment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(uploadAttachmentOfComments.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(uploadAttachmentOfComments.fulfilled, (state, action) => {
        state.loading = false;
        state.uploadedListAttachmentOfComments = [
          ...state.uploadedListAttachmentOfComments,
          action.payload.data,
        ];
        state.error = null;
      })
      .addCase(uploadAttachmentOfComments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(editCommentById.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(editCommentById.fulfilled, (state, action) => {
        if (action.payload.data?.length) {
          state.comments = action.payload.data;
        }
        state.editCommenttoaster = true;
        state.loading = false;
        state.error = null;
      })
      .addCase(editCommentById.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.data;
      });
    builder
      .addCase(deleteComment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.data;
      })
      .addCase(deleteComment.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteComment.fulfilled, (state, action) => {
        state.comments = action.payload?.data;
        state.total = state.total - 1;
        state.deleteCommenttoaster = true;
        state.loading = false;
        state.error = null;
      });
    builder
      .addCase(getCommentsByWorkFlowId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCommentsByWorkFlowId.fulfilled, (state, action) => {
        state.loading = false;
        state.comments = action.payload?.data;
        state.total = action.payload.count;
        state.error = null;
      })
      .addCase(getCommentsByWorkFlowId.rejected, (state, action) => {
        state.loading = false;
        state.comments = null;
        state.error = action.payload;
      });
  },
});

export const {
  setStart,
  setLimit,
  setSortBy,
  setSortOrder,
  setError,
  setLoading,
  setComments,
  clearComments,
  resetCommentsState,
  deleteAnUploadedFileFromAttachment,
  clearUploadedListAttachmentOfComments,
  setAddedNewComment,
  resetAddedNewComment,
  setdeleteComment,
  seteditComment,
  setSelectedComment,
  setSelectedCommentAttachment,
  setdeleteAttachedComment,
  updateAttachments,
  clearSelectedComment,
  reseteditCommenttoaster,
  resetdeleteCommenttoaster
} = commentsReducer.actions;

export default commentsReducer.reducer;
